import { Form } from 'antd';
import cashierService from 'modules/POS/services';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import BillSelectionItem from './Item';
import React from 'react';
export const bilSelectionRef = React.createRef<HTMLDivElement>();
const BillSelections = () => {
  const dispatch = useAppDispatch();
  const activeItemLatestId = cashierService.selectors.activeItemLatestId();
  return (
    <Container>
      <div className="selected-product">
        <div ref={bilSelectionRef} className="container-wrapper">
          <Form.List name={'items'}>
            {(fields, { remove }) => (
              <>
                {fields.map(({ key, name }, index) => (
                  <Form.Item name={name} key={key} noStyle>
                    <BillSelectionItem activeItemLatestId={activeItemLatestId} name={name} index={index} remove={() => {
                      dispatch(cashierService.actions.setActiveItemLatest(''));
                      remove(name);
                    }} />
                  </Form.Item>
                ))}
              </>
            )}
          </Form.List>
        </div>
      </div>
    </Container>
  );
};

export default BillSelections;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  .selected-product {
    flex: 1;
    position: relative;
  }
  .container-wrapper {
    position: absolute;
    inset: 0;
    overflow: auto;
  }
`;